// extracted by mini-css-extract-plugin
export default {"imgdiv":"_70bece2c86 a49e6bc424","img":"_5126158de9 _7913e5d20c"};